<template>
  <div class="MailAddressChangeConfirmation">
    <section-header v-if="isChange" heading="2" ja="メールアドレス変更確認"/>
    <section-header v-else heading="2" ja="メールアドレス登録確認"/>

    <div class="mailaddresschange-discription">
      <p v-if="isChange">
        ご入力いただいたメールアドレスに、変更確認メールを送信しました。
      </p>
      <p v-else>
        ご入力いただいたメールアドレスに、登録確認メールを送信しました。
      </p>
      <p class="address">{{ mailAddress }}</p>
      <p v-if="isChange">
        メールに記載されているURLより、メールアドレスの変更手続きを行ってください。<br>
        なお、メールが届かない場合は、お手続きが完了できませんので、ドメイン指定受信などをされている方は @puri.jp からのメールを受信できるよう設定をお願いいたします。
      </p>
      <p v-else>
        メールに記載されているURLより、メールアドレスの登録手続きを行ってください。<br>
        なお、メールが届かない場合は、お手続きが完了できませんので、ドメイン指定受信などをされている方は @puri.jp からのメールを受信できるよう設定をお願いいたします。
      </p>
    </div>



  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'

export default {
  name: "MailAddressChange",
  components: {
    SectionHeader
  },
  data () {
    return {
      mailAddress: this.$route.params.mailAddress
    }
  },
  computed: {
    isChange() {
      return this.$store.getters.mailAddress !== ''
    }
  }
}
</script>

<style scoped>
.address{
  margin: 1rem 0;
}
.mailaddresschange-discription {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
